import { render, staticRenderFns } from "./CardPleaseWait.vue?vue&type=template&id=a8590e8a&"
import script from "./CardPleaseWait.vue?vue&type=script&lang=js&"
export * from "./CardPleaseWait.vue?vue&type=script&lang=js&"
import style0 from "./CardPleaseWait.vue?vue&type=style&index=0&id=a8590e8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports